import React from 'react';
import { FiStar, FiTrash2 } from 'react-icons/fi';
import { formatDistanceToNow } from 'date-fns';

function MemoryFactRow({ fact, onTogglePin, onDelete }) {
  return (
    <li className={`memory-fact-row ${fact.pinned ? 'is-pinned' : ''}`}>
      <p>{fact.text}</p>
      <div className="memory-fact-actions">
        <time>{formatDistanceToNow(new Date(fact.updatedAt), { addSuffix: true })}</time>
        <button
          aria-label={fact.pinned ? 'Unpin fact' : 'Pin fact'}
          aria-pressed={fact.pinned}
          className="icon-button"
          onClick={() => onTogglePin(fact.id)}
          title={fact.pinned ? 'Unpin' : 'Pin'}
          type="button"
        >
          <FiStar />
        </button>
        <button
          aria-label="Delete fact"
          className="icon-button danger"
          onClick={() => onDelete(fact.id)}
          title="Delete"
          type="button"
        >
          <FiTrash2 />
        </button>
      </div>
    </li>
  );
}

export default MemoryFactRow;
